module.exports = __webpack_public_path__ + "img/d-7.64f9196e.png";